import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../_services/storage.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  return inject(StorageService).loggedIn()
    ? true
    : inject(Router).navigate(['/login']);
};